import applyCreate from './modules/create';
import applyUpdate from './modules/update';

export default {
  applyCreate,
  applyUpdate,
};
